<h1 mat-dialog-title class="edit-form-title">{{ title }}</h1>

<mat-dialog-content class="edit-form-content">

  <form class="edit-form" [formGroup]="editForm">

    <div class="detail-section">
      <div class="content-container">

        <div class="input-row">
          <mat-form-field appearance="fill" class="custom-filled code">
            <mat-label>Code</mat-label>
            <input matInput formControlName="code" maxlength="10" readonly>
          </mat-form-field>

          <mat-form-field appearance="fill" class="custom-filled category">
            <mat-label>Category</mat-label>
            <input matInput formControlName="category_name" readonly>
          </mat-form-field>
        </div>

        <div class="input-row">
          <mat-form-field appearance="fill" class="custom-filled department">
            <mat-label>Department</mat-label>
            <input matInput formControlName="department_name" readonly>
          </mat-form-field>

          <mat-form-field appearance="fill" class="custom-filled payroll-code">
            <mat-label>Payroll Code</mat-label>
            <input matInput formControlName="payroll_code">

            <mat-error *ngIf="editForm.get('payroll_code')?.hasError('required')">
              Payroll Code should be entered
            </mat-error>

            <mat-error *ngIf="editForm.get('payroll_code')?.hasError('maxlength')">
              Maximum length is 7.
            </mat-error>
          </mat-form-field>
        </div>

        <div class="input-row" style="margin-top: 8px;">
          <mat-checkbox formControlName="fixed_pay">Fixed Pay</mat-checkbox>
        </div>

      </div>
    </div>

  </form>

</mat-dialog-content>

<mat-dialog-actions align="end" class="footer">
  <button mat-flat-button class="action-btn btn-save" (click)="save()" type="button">SAVE</button>
  <button mat-button class="action-btn btn-discard" (click)="navBack()">DISCARD</button>
</mat-dialog-actions>
